import { render, staticRenderFns } from "./TeacherTrainDetial.vue?vue&type=template&id=4bc770da&scoped=true"
import script from "./TeacherTrainDetial.vue?vue&type=script&lang=js"
export * from "./TeacherTrainDetial.vue?vue&type=script&lang=js"
import style0 from "./TeacherTrainDetial.vue?vue&type=style&index=0&id=4bc770da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc770da",
  null
  
)

export default component.exports